'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { ConversionAssetPosition } from '../../constants/video';
import { formatCustomTime } from '../../utils/video';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConversionAssetSummary = ({
  paddingInlineStart,
  conversionAsset
}) => {
  if (!conversionAsset || !conversionAsset.type) {
    return null;
  }
  let position = conversionAsset.position || ConversionAssetPosition.PRE;
  if (position === ConversionAssetPosition.CUSTOM && !conversionAsset.overlay_delay_seconds) {
    position = ConversionAssetPosition.PRE;
  }
  const timeDisplay = formatCustomTime(conversionAsset.overlay_delay_seconds || 0);
  const positionEl = /*#__PURE__*/_jsx(FormattedMessage, {
    message: `RichTextLib.video.conversionAssetSummary.position.${position.toLowerCase()}`,
    options: {
      timeDisplay
    }
  });
  const canSkipEl = /*#__PURE__*/_jsx(FormattedMessage, {
    message: conversionAsset.prevent_skip ? 'RichTextLib.video.conversionAssetSummary.preventSkip' : 'RichTextLib.video.conversionAssetSummary.allowSkip'
  });
  return /*#__PURE__*/_jsxs(List, {
    paddingInlineStart: paddingInlineStart,
    styled: true,
    children: [/*#__PURE__*/_jsx(ListItem, {
      children: positionEl
    }), /*#__PURE__*/_jsx(ListItem, {
      children: canSkipEl
    })]
  });
};
export default ConversionAssetSummary;